import React from 'react'
import { richTextAsText } from '../../../utils/prismic'
import YourFundsSection from '../../sections/YourFundsSection'
import { YourFundsSectionSliceProps } from './types'

const YourFundsSectionSlice: React.FC<YourFundsSectionSliceProps> = ({ slice }) => (
  <YourFundsSection
    id={slice.slice_type}
    isMainHeading={slice.primary?.is_main_heading}
    heading={richTextAsText(slice.primary?.title?.raw)}
    subheading={richTextAsText(slice.primary?.description?.raw)}
    inner="inners.small"
    paddingTop={['80px', '', '186px']}
    paddingBottom={['80px', '', '200px']}
    headingPadding={['38px', '', '87px']}
    bgColor="grayLight"
    data={(slice.items || [])?.map((item, index) => ({
      key: index,
      title: richTextAsText(item?.title?.raw),
      desc: richTextAsText(item?.description?.raw),
      image: {
        dimensions: {
          width: 47,
          height: 63
        },
        alt: item?.image?.alt,
        url: item?.image?.url
      }
    }))}
  />
)

export default YourFundsSectionSlice
